import React, { useState, useEffect } from "react";
import { IoMdAdd } from "react-icons/io";
import { FaMinus } from "react-icons/fa6";
import AOS from "aos";
import "aos/dist/aos.css";
import api from "../../utilis/api"; // make sure this points to your axios instance

const Faqs = () => {
  const [faqs, setFaqs] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  // Initialize AOS animations
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-out",
      once: false,
      mirror: true,
    });
  }, []);

  // Fetch FAQs from backend
  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const res = await api.get("/faq"); // GET /faq
        if (res?.data?.success) {
          setFaqs(res.data.data); // set state with backend data
        }
      } catch (error) {
        console.error("Error fetching FAQs:", error);
      }
    };

    fetchFaqs();
  }, []);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="bg-white text-white flex justify-center">
      <div className="w-full max-w-7xl px-4 pt-20 pb-16 flex flex-col gap-6 items-center">
        {faqs.length > 0 ? (
          faqs.map((faq, index) => (
            <div
              key={faq._id} // use backend _id as key
              className="w-full sm:w-[90%] md:w-[700px] px-4 py-4 border border-[#000] rounded-xl"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              {/* Question Button */}
              <button
                onClick={() => toggleFAQ(index)}
                className="flex items-center justify-between w-full text-left"
              >
                <p className="text-[16px] text-black sm:text-[18px] md:text-[20px] font-Syne">
                  {faq.question}
                </p>
                {activeIndex === index ? (
                  <FaMinus className="text-[#000] text-lg sm:text-xl" />
                ) : (
                  <IoMdAdd className="text-[#000] text-lg sm:text-xl" />
                )}
              </button>

              {/* Answer Content */}
              <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  activeIndex === index
                    ? "max-h-60 py-4 opacity-100"
                    : "max-h-0 opacity-0"
                }`}
              >
                <p className="text-gray-400 text-[14px] sm:text-[16px] md:text-[18px] font-Outfit">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))
        ) : (
          <p className="text-black text-lg mt-4">No FAQs available.</p>
        )}
      </div>
    </div>
  );
};

export default Faqs;
